<template>
  <div class="px-8">
    <v-row>
      <v-col cols="12">
        <h3>What is it called?</h3>
        <v-text-field
          label=""
          v-model.trim="doc.title"
          type="text"
          placeholder="Give your object a title"
          id="title"
        ></v-text-field>
        <h3>Upload an image</h3>
        <upload @updatedSrc="getSrc" :preview="doc"></upload>
      </v-col>
      <v-col cols="12">
        <h3>What emotion does it convey?</h3>
        <v-text-field
          label=""
          v-model.trim="doc.emotion"
          type="text"
          placeholder="Think of an emotion"
        ></v-text-field>
        <h3>What is its Super Power?</h3>
        <v-text-field
          label=""
          v-model.trim="doc.power"
          type="text"
          placeholder="Think of a super power"
        ></v-text-field>
        <h3 class="mb-4">What are its characteristics?</h3>
        <unit-sub-items v-model="doc.attributes" name="sub">
          <p class="ma-0">Type below and press <strong>Add</strong></p>
        </unit-sub-items>
        <h3 class="mb-4 mt-8">Summary</h3>
        <p v-if="loading">Generating summary...</p>
        <p v-else-if="doc.summary" class="title mt-4" v-html="doc.summary"></p>
        <p v-else>Press the 'Summarise' button to generate a summary</p>

        <v-btn color="white" class="mt-4" @click="generateSummary()"
          >Summarise</v-btn
        >
        <div class="d-flex mt-8">
          <v-btn color="amber" class="" @click="$emit('save')">Save</v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { Upload } from "@/components/functionality";
import { UnitSubItems } from "@/components/units";

export default {
  name: "MuseumForm",
  components: { Upload, UnitSubItems },
  data() {
    return {
      isValid: true,
      messages: [],
      loading: false,
    };
  },
  props: {
    doc: Object,
  },
  methods: {
    getSrc(val) {
      this.doc.src = val;
    },
    validateImage(val) {
      this.isValidImage = val;
    },
    async generateSummary() {
      this.loading = true;
      const content = [];
      const messages = [];
      content.push(
        "Summarise the following characteristics into a short sentence as if they were an organisation"
      );
      content.push(this.doc.title);
      content.push(this.doc.emotion);
      content.push(this.doc.power);
      const attributes = this.doc.attributes.join(",");
      content.push(attributes);
      console.log("content", content);

      // // Add user's message to the chat
      messages.push({ role: "user", content: content.join(",") });

      try {
        // Send the user's message to the Express server
        const response = await axios.post(
          "https://chat.makelemonade.uk/api/chat",
          {
            messages: messages,
          }
        );

        // Add ChatGPT's response to the chat
        const assistantMessage = response.data.choices[0].message;
        this.doc["summary"] = assistantMessage.content;
        this.loading = false;
        this.$emit("saveSilent");
      } catch (error) {
        console.error("Error communicating with the server:", error);
        this.loading = false;
      }
    },
  },
};
</script>
